import { FC, useRef, useState } from 'react'
import { styled } from 'styled-components'
import React from 'react'
import { Text } from '../text/textStyles'
import ArrowIcon from '@tuhi/components/assets/icons/buttons/calendarDropdownArrow.svg'
import { useSubscribeToClickOutsideEvent } from '../../hooks'
import { BaseButton } from '../../components'

const Container = styled.div<{ $width: number }>`
    display: flex;
    flex-direction: column;
    position: relative;
    gap: 4px;
    width: ${(p) => p.$width}px;
`

const DropdownButton = styled.button<{ $isFocused: boolean }>`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 12px;
    gap: 10px;
    border-radius: 6px;
    border: 2px solid
        ${(p) =>
            p.$isFocused
                ? p.theme.colors.primary.default
                : p.theme.colors.tertiary.tertiary50};
    background-color: ${(p) => p.theme.colors.white};
    color: ${(p) => p.theme.colors.tertiary.tertiary900};
    z-index: 1;
`

const Options = styled.div`
    display: flex;
    flex-direction: column;
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    border-radius: 6px;
    border: 1px solid ${(p) => p.theme.colors.tertiary.tertiary200};
    border-top: none;
    box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.25);
    padding: 0 4px;

    background-color: white;
    overflow: auto;
    max-height: 245px;
`

const Option = styled(BaseButton)`
    justify-content: start;

    height: 36px;

    padding: 10px 8px;

    &:hover {
        border-radius: 6px;
        background-color: ${(p) => p.theme.colors.primaryGrey};
    }
`

interface Props {
    options: string[]
    defaultOption: string
    highlightedOption: string
    onSelect: (selectedOption: string) => void
    width: number
}

export const CalendarDropdown: FC<Props> = ({
    options,
    defaultOption,
    highlightedOption,
    onSelect,
    width,
}) => {
    const [openMenu, setOpenMenu] = useState(false)

    const ref = useRef(null)

    useSubscribeToClickOutsideEvent(ref, () => {
        setOpenMenu(false)
    })

    return (
        <Container ref={ref} $width={width}>
            <DropdownButton
                onFocus={() => setOpenMenu(true)}
                $isFocused={openMenu}
            >
                <Text size="xLarge" $weight="bold">
                    {defaultOption}
                </Text>
                <ArrowIcon />
            </DropdownButton>

            {options.length > 0 && openMenu && (
                <Options>
                    {options.map((option) => (
                        <Option
                            key={option}
                            onClick={() => {
                                setOpenMenu(false)
                                onSelect(option)
                            }}
                        >
                            <Text
                                size="medium"
                                $weight="regular"
                                color={
                                    option == highlightedOption
                                        ? 'brand'
                                        : 'primary'
                                }
                                $underline={option == highlightedOption}
                            >
                                {option}
                            </Text>
                        </Option>
                    ))}
                </Options>
            )}
        </Container>
    )
}
